<template>
  <component
    :is="isExternal ? 'a' : 'router-link'"
    :to="isExternal ? null : to"
    :href="isExternal ? to : null"
    :target="isExternal ? '_blank' : null"
    class="custom-router-link"
    :class="[size, variant, customClass]"
    @click="handleClick"
  >
    <slot v-if="$slots.icon" name="icon" />
    <span v-if="text || $slots.default">
      <slot>{{ text }}</slot>
    </span>
    <slot v-if="$slots.trailingIcon" name="trailingIcon" />
  </component>
</template>

<script>
export default {
  name: 'RouteLink',
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'outline', 'text'].includes(value)
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        return;
      }
      this.$emit('click', event);
    }
  }
};
</script>

<style scoped>
.custom-router-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.custom-router-link:disabled,
.custom-router-link.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Size Variants */
.small {
  padding: 6px 12px;
  font-size: 0.875rem;
}

.medium {
  padding: 10px 20px;
  font-size: 1rem;
}

.large {
  padding: 14px 28px;
  font-size: 1.125rem;
}

/* Style Variants */
.primary {
  background-color: #3498db;
  color: white;
  border: none;
}

.primary:hover:not(:disabled) {
  background-color: #2980b9;
}

.secondary {
  background-color: #2c3e50;
  color: white;
  border: none;
}

.secondary:hover:not(:disabled) {
  background-color: #1a252f;
}

.outline {
  background-color: transparent;
  color: #3498db;
  border: 2px solid #3498db;
}

.outline:hover:not(:disabled) {
  background-color: #3498db;
  color: white;
}

.text {
  background-color: transparent;
  color: #3498db;
  border: none;
  padding: 0;
}

.text:hover:not(:disabled) {
  text-decoration: underline;
}
</style>